import { REQUEST_QUOTATIONS } from "../types/RequestQuotationAction";

export const getRequestQuotationList = ({page = 1, limit = 10, targetedBusinessType = []} = {}) => {
  return {
    type: REQUEST_QUOTATIONS.GET_REQUEST_QUOTATIONS_LIST,
    payload: {
      page,
      limit,
      targetedBusinessType
    }
  };
};

export const getFreightRateRFQs = ({page = 1, limit = 10, targetedBusinessType = []} = {}) => {
  return {
    type: REQUEST_QUOTATIONS.GET_FREIGHT_RATE_RFQS,
    payload: {
      page,
      limit,
      targetedBusinessType
    }
  };
};

export const getChaRFQs = ({page = 1, limit = 10, targetedBusinessType = []} = {}) => {
  return {
    type: REQUEST_QUOTATIONS.GET_CHA_RFQS,
    payload: {
      page,
      limit,
      targetedBusinessType
    }
  };
};

export const getManufacturerRFQs = ({page = 1, limit = 10, targetedBusinessType = []} = {}) => {
  return {
    type: REQUEST_QUOTATIONS.GET_MANUFACTURER_RFQS,
    payload: {
      page,
      limit,
      targetedBusinessType
    }
  };
}

export const deleteRFQDataAction = (RFQ_id) => {
  return {
    type: REQUEST_QUOTATIONS.DELETE_QUOTATIONS_FROM_LIST,
    RFQ_id,
  };
};

export const searchRFQDataAction = (searchText) => {
  return {
    type: REQUEST_QUOTATIONS.GET_SEARCH_QUOTATIONS_FROM_LIST,
    searchText,
  };
};

export const searchRFQDataActionWithEmail = (searchText) => {
  return {
    type: REQUEST_QUOTATIONS.GET_SEARCH_QUOTATIONS_FROM_LIST_WITH_EMAIL_ID,
    searchText,
  };
};

export const getMessagesAction = (isQuotation, id, loggedInUserId) => {
  return {
    type: REQUEST_QUOTATIONS.GET_MESSAGES,
    isQuotation,
    id,
    loggedInUserId,
  };
};
